import { AvatarGroup, Box, CardMedia, styled } from "@mui/material";
import { FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const trackControlsStyles = {
  playbackIcons: { height: 25, width: 25 } as const,
};

export const trackDetailsStyles = {
  titleArtist: { flexGrow: 1, marginLeft: 5 } as const,
  title: {
    fontFamily: FONT_FAMILY,
    fontSize: 14,
    fontWeight: "bold",
  } as const,
  artist: { fontFamily: FONT_FAMILY, fontSize: 14 } as const,
};

export const versionDetailsStyles = {
  currentVersionLabel: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    fontWeight: "bold",
  } as const,
  CurrentVersionCount: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    fontWeight: "bold",
  } as const,
};

export const menuItemsStyles = {
  menuItem: {
    display: "flex",
    justifyContent: "center",
  } as const,
  menuButtons: {
    textTransform: "none",
    fontFamily: FONT_FAMILY,
    fontSize: 15,
  } as const,
};

export const waveformDetailsStyles = {
  spinner: { marginTop: 10, marginLeft: 10 } as const,
  linearProgressContainer: {
    flexGrow: 1,
    marginBottom: 5,
    marginTop: 5,
    color: "#27B6CB",
  } as const,
  waveform: {
    minWidth: "100%",
    overflow: "hidden",
    marginTop: "25px",
  } as const,
};

export const CollaboratorsStyles = {
  genreText: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    color: TEXT_COLOR,
  } as const,
  genreLabel: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    color: TEXT_COLOR,
    fontWeight: "bold",
  } as const,
  contributorsPhotoContainer: {
    display: "flex",
    alignItems: "end",
    color: "black",
  } as const,
  contributorNavLink: {
    marginRight: "5px",
    textDecoration: "none",
    fontFamily: FONT_FAMILY,
    color: "#27B6CB",
  } as const,
  contributorsPhotos: {
    width: "35px",
    height: "35px",
    marginLeft: "1px",
    borderRadius: "50%",
    marginBottom: "5px",
    backgroundColor: "#1A8899",
  } as const,
  playbackIcons: { height: 25, width: 25 } as const,
};

export const StyledCardMedia = styled(CardMedia)(({ theme }) => ({
  marginTop: 15,
  marginLeft: 5,
  padding: 5,
  borderRadius: 10,
  width: "140px",
  height: "140px",
  display: "flex",
  justifyContent: "center",
  ".MuiCardMedia-img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  [theme.breakpoints.down("md")]: {
    marginTop: 30,
    marginLeft: 10,
    padding: 30,
    width: "80px",
    height: "80px",
  },
  [theme.breakpoints.down("sm")]: {
    marginTop: 30,
    marginLeft: 10,
    minWidth: "25px",
    minHeight: "25px",
    borderRadius: "10%",
  },
  [theme.breakpoints.down("xs")]: {
    display: "none",
  },
}));

export const StyledCardMediaMyTrack = styled(CardMedia)(({ theme }) => ({
  marginTop: 5,
  marginLeft: 5,
  padding: 5,
  borderRadius: 10,
  width: "110px",
  height: "110px",
  ".MuiCardMedia-img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  [theme.breakpoints.down("md")]: {
    marginTop: 30,
    marginLeft: 10,
    padding: 30,
    width: "65px",
    height: "65px",
  },
  [theme.breakpoints.down("sm")]: {
    marginTop: 30,
    marginLeft: 10,
    minWidth: "25px",
    minHeight: "25px",
    borderRadius: "10%",
  },
  [theme.breakpoints.down("xs")]: {
    display: "none",
  },
}));

export const TrackDetailsContainer = styled(Box)(({ theme }) => ({
  maxWidth: "calc(100%)",
  textOverflow: "ellipsis",
  textAlign: "left",
  alignContent: "left",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "calc(80%)",
  },
}));

export const WaveformContainer = styled("div")(({ theme }) => ({
  height: "50%",
  alignItems: "center",
  display: "flex",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const GenresDetailsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginRight: "20px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const TrackMenuContainer = styled(Box)(({ theme }) => ({
  minWidth: "280px",
  zIndex: "1000",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const MessageContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
}));

export const GenresAndContributorsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  marginLeft: "auto",
  marginRight: "20px",
}));

export const ContributorsContainer = styled(AvatarGroup)(({ theme }) => ({
  marginLeft: "auto",
  marginRight: "5px",
  "& .MuiAvatar-root": {
    fontSize: 18,
    fontFamily: FONT_FAMILY,
    backgroundColor: "#25486e",
    color: "#cfcfcf",
  },
  zIndex: 1000,
}));

export const trackComponentStyles = {
  timeSpanContainer: {
    width: "50px",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
  } as const,
  circularProgressContainer:{
    display: "grid",
    justifyItems: "center",
    alignItems: "center",
  }as const,
  trackComponentMainContainer:{
    margin: "8px 0 8px 0px",
    borderRadius: "10px",
    zIndex: 0,
    transition: "transform 0.3s ease-in-out",
  }as const,
  tab:{
    textTransform: "none",
    fontFamily: FONT_FAMILY,
    fontWeight: 600,
    fontSize: 16,
  }as const,

};

